// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Wqd9i","isFull":"styles_isFull__9Wmmi","isOpen":"styles_isOpen__JrBwJ"};